import { Box, makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import './style.scss';
import { useVisualViewport } from 'utils/useVisaulViewport';
import { TRACK_EVENT, trackEvent } from 'utils/analytics';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { STRINGS } from 'constants/strings';

export default function SessionIntroCard() {
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const useStyles = makeStyles(() => ({
        sliderContainer: {
            // maxHeight: 'calc(100vh - 100px)'
            position: 'relative',
        },
        slideImage: {
            backgroundSize: 'cover',
            borderRadius: '11px',
        },
        overlayContainer: {
            margin: '0 12px',
            zIndex: 'inherit',
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        styleTitle: {
            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
            fontSize: 21,
            color: '#544A3C',
            cursor: 'pointer',
        },
        subTitle: {
            fontSize: 14,
            fontWeight: 500,
            color: '#544A3C',
            fontFamily: 'Poppins',
            margin: 0,
            cursor: 'pointer',
            marginBottom: '12px',
        },
        button: {
            fontSize: 14,
            fontWeight: 500,
            color: '#544A3C',
            textTransform: 'uppercase',
            fontFamily: 'Poppins',
            margin: 0,
            cursor: 'pointer',
        },
        playVideoButton: {
            bottom: 12,
            right: 12,
            zIndex: 'inherit',
            maxWidth: '100%',
            position: 'absolute',
            cursor: 'pointer',
        },
    }));
    const classes = useStyles();
    const history = useHistory();

    const imageDiv = useRef<HTMLDivElement>(null);
    // eslint-disable-next-line
    const [imageHeight, setImageHeight] = useState(0);
    const screen = useVisualViewport();
    useEffect(() => {
        if (imageDiv.current) {
            let dynamicHeight = imageDiv?.current?.offsetWidth / 2.3;
            setImageHeight(dynamicHeight);
        }
    }, [screen?.viewport?.height]);

    const navigateToSessionIntro = () => {
        trackEvent(TRACK_EVENT.HOME_PAGE_AMIRA_BANNER_CLICKED, {
            userId: userDetail?.id,
            userEmail: userDetail?.email,
            name: `${userDetail?.firstName} ${userDetail?.lastName}`,
            messageText: `${STRINGS.HOME_BANNER_TOP_TEXT}. ${STRINGS.HOME_BANNER_BOTTOM_TEXT}`,
            ctaLinkText: STRINGS.HOME_BANNER_CTA_TEXT,
        });
        history.push(PATH.STYLE_ASSISTANT);
    };

    return (
        <div style={{ paddingTop: `24px` }} className="highlightContainer">
            <Box className={`${classes.sliderContainer} d-flex justify-content-center`} px={'14px'}>
                <div
                    style={{
                        backgroundColor: '#F7EADF',
                        height: '112px',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                    ref={imageDiv}
                    onClick={navigateToSessionIntro}
                    className={`${classes.slideImage} w-100`}
                >
                    <div className={`${classes.overlayContainer}`}>
                        <div className={classes.styleTitle}>{STRINGS.HOME_BANNER_TOP_TEXT}</div>
                        <div className={classes.subTitle}>{STRINGS.HOME_BANNER_BOTTOM_TEXT}</div>
                        <p className={`${classes.button}`}>
                            {STRINGS.HOME_BANNER_CTA_TEXT} <ArrowForward />
                        </p>
                    </div>
                    {/* for next enhancement */}
                    {/* <span className={classes.playVideoButton}>
                        <PlayVideo style={{ width: 24, height: 24 }} />
                    </span> */}
                </div>
            </Box>
        </div>
    );
}
